import { ProgressRing } from "../primitives/ProgressRing";
import { AnimatedNumber } from "../primitives/AnimatedNumber";
import { cn } from "../../lib/cn";

interface ReadinessRingProps {
  score: number;
  size?: number;
  className?: string;
}

function getColor(score: number): string {
  if (score >= 70) return "var(--vitals-green)";
  if (score >= 40) return "var(--vitals-amber)";
  return "var(--vitals-red)";
}

function getLabel(score: number): string {
  if (score >= 80) return "Ready";
  if (score >= 60) return "Almost";
  if (score >= 30) return "Draft";
  return "Early";
}

function ReadinessRing({ score, size = 72, className }: ReadinessRingProps) {
  const color = getColor(score);

  return (
    <div className={cn("flex flex-col items-center gap-1", className)}>
      <ProgressRing
        value={score}
        max={100}
        size={size}
        strokeWidth={5}
        fillColor={color}
      >
        <AnimatedNumber
          value={score}
          format={(n) => `${Math.round(n)}`}
          className="text-base font-bold text-[var(--text-primary)] tabular-nums"
        />
      </ProgressRing>
      <span className="text-[10px] font-semibold uppercase tracking-wider" style={{ color }}>
        {getLabel(score)}
      </span>
      <span className="text-[9px] text-[var(--text-muted)]">Submission Readiness</span>
    </div>
  );
}

ReadinessRing.displayName = "ReadinessRing";

export { ReadinessRing };
export type { ReadinessRingProps };
